export default __webpack_public_path__ + "static/media/Google Digital Garage Digital Marketting.3527f64e.webp";